module.exports = __webpack_public_path__ + "static/media/IMG_5663.44f01f88.JPG";